import { formatCurrency  } from './cart';
import {hideLoading, loadingHtml} from "../components/loading";


export function init() {
  $(document).ready(function() {
    loadProductCartIntoCheckoutPage();
    loadProvince();
    let typingTimer;
    const taxVatEle = $('.tax-vat');
    const location = {
      province: null,
      district: null,
      ward: null,
      address: null
    }

    const invoice = {
      tax_code: null,
      company_name: '',
      company_address: '',
      company_email: ''
    }

    $('#selected-province').select2();
    $('#selected-district').select2();
    $('#selected-ward').select2();
    taxVatEle.hide();

    $('.show-input-address').on('click', function(event) {
      event.preventDefault();
      location.address = null;
      $('.input-address').removeClass('d-none');
      $('.select-location').prop('required', true);
      $('.show-address').html('');
    });

    $('.show-input-company').on('click', function(event) {
      event.preventDefault();
      $('.invoice-info').removeClass('d-none');
      $('#exportInvoice input').prop('required', true);
      $('.show-company').html('');
    });

    $('input[name="address"]').change(function(){
      location.address = $(this).closest('.address').find('.address-data').text();
    });

    $('input[name="company"]').change(function() {
      invoice.tax_code = $(this).siblings('label').find('.company-tax-data').text();
      invoice.company_name = $(this).siblings('label').find('.company-name-data').text();
      invoice.company_email = $(this).siblings('label').find('.company-email-data').text();
      invoice.company_address = $(this).siblings('label').find('.company-address-data').text();
    });


    $('.receiver_phone').keyup(() => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        axios.get('/get-info', {
          params: {
            'phone': $('.receiver_phone').val(),
          }
        }).then(response => {
          const addresses = response.data.addresses;
          const companies = response.data.companies;
          const showAddressEle = $('.show-address');
          const inputAddressEle = $('.input-address');
          const showCompanyEle = $('.show-company');
          const inputCompanyEle = $('.invoice-info');
          showAddressEle.html('');
          showCompanyEle.html('');
          if (addresses.length > 0) {
            addresses.forEach((item, index) => {
              if (item.is_default === 1 || index === 0) {
                location.address = item.address;
                $('.receiver_note').val(item.describe)
              }
              const addressInput = $(`
                <input type="radio" name="address" id="address${index}" ${index === 0 ? 'checked' : ''}>
              `);

              const label = $(`
                <label for="address${index}" class="px-3 py-2 w-100">
                  <div class="d-flex align-items-center">
                    <h4 class="m-0">${item.phone}</h4>
                    ${item.is_default ? `<span class="default p-1">Mặc định</span>` : ''}
                  </div>
                  <div>
                    <p class="address-data">${item.address}</p>
                  </div>
                </label>
              `);

              const addressDiv = $(`<div class="address"></div>`);

              addressDiv.append(addressInput).append(label);

              showAddressEle.append(addressDiv);


              addressInput.on('change', function() {
                location.address = $(this).siblings('label').find('.address-data').text();
                $('.receiver_note').val(item.describe)
              });
            });

            showAddressEle.append(`
              <div class="d-flex justify-content-end">
                <a href="#" class="show-input-address">
                  + Thêm địa chỉ mới
                </a>
              </div>
            `);

            $('.show-input-address').on('click', function(event) {
              event.preventDefault();
              location.address = null;
              inputAddressEle.removeClass('d-none');
              showAddressEle.html('');
            });

            inputAddressEle.addClass('d-none');
          } else {
            inputAddressEle.removeClass('d-none');
          }

          if (companies.length > 0) {
            showCompanyEle.data('show', true);
            companies.forEach((item, index) => {
              if (index === 0) {
                invoice.tax_code = item.tax_code;
                invoice.company_name = item.company_name;
                invoice.company_email = item.company_email;
                invoice.company_address = item.company_address;
              }
              const companySelect = $(`
                <input type="radio" name="company" id="company${index}" ${index === 0 ? 'checked' : ''}>
              `);

              const label = $(`
                <label for="company${index}" class="px-3 py-2 w-100">
                  <div class="d-flex align-items-center">
                    <h4 class="m-0 company-tax-data">${item.tax_code}</h4>
                  </div>
                  <div>
                    <p class="company-name-data">${item.company_name}</p>
                    <p class="company-email-data">${item.company_email}</p>
                    <p class="company-address-data">${item.company_address}</p>
                  </div>
                </label>
              `);

              const companyDiv = $(`<div class="company"></div>`);

              companyDiv.append(companySelect).append(label);

              showCompanyEle.append(companyDiv);

              companySelect.on('change', function() {
                invoice.tax_code = $(this).siblings('label').find('.company-tax-data').text();
                invoice.company_name = $(this).siblings('label').find('.company-name-data').text();
                invoice.company_email = $(this).siblings('label').find('.company-email-data').text();
                invoice.company_address = $(this).siblings('label').find('.company-address-data').text();
              });
            });

            showCompanyEle.append(`
                <div class="d-flex justify-content-end">
                  <a href="#" class="show-input-company">
                    + Thêm mã số thuế mới
                  </a>
                </div>
              `);

            $('.show-input-company').on('click', function(event) {
              event.preventDefault();
              inputCompanyEle.show();
              showCompanyEle.html('');
              $('#exportInvoice input').prop('required', true);
            });
            inputCompanyEle.hide();
          } else {
            inputCompanyEle.show();
          }
        })
          .catch(error => {
            console.error('Error:', error);
          });
      }, 500);
    })

    $('#selected-province').change(function() {
      const provinceCode = $(this);

      const data = {
        'province_code': provinceCode.val(),
      }

      axios.get('/get-districts', { params: data })
        .then(response => {
          let selectDistrict = $('#selected-district');
          const districts = response.data.districts;
          selectDistrict.html(`<option value="">Chọn quận/huyện</option>`);
          districts.forEach(item => {
            selectDistrict.append(`<option data-name="${item.name_with_type}" value="${item.code}">${item.name_with_type}</option>`);
          });

          location.province = provinceCode.find('option:selected').data('name');
        })
        .catch(error => {
          console.error('Error:', error);
        });
    });

    $('#selected-district').change(function() {
      const districtCode = $(this);

      const data = {
        'district_code': districtCode.val(),
      }

      axios.get('/get-wards', { params: data })
        .then(response => {
          let selectWards = $('#selected-ward');
          const wards = response.data.wards;
          selectWards.html(`<option value="">Chọn phường/xã</option>`);
          wards.forEach(item => {
            selectWards.append(`<option data-name="${item.name_with_type}" value="${item.code}">${item.name_with_type}</option>`);
          });
          location.district = districtCode.find('option:selected').data('name');
        })
        .catch(error => {
          console.error('Error:', error);
        });
    });

    $('#selected-ward').change(function() {
      location.ward = $(this).find('option:selected').data('name');
    });


    $('#form-checkout').on('submit', (e) => {
      e.preventDefault();
      $('#checkout').append(loadingHtml());
      const order = getOrder();
      const street = $('.address-detail').val();

      if (invoice.tax_code == null) {
        invoice.tax_code = $('.company-tax-code').val() ?? null;
        invoice.company_name = $('.company-name').val();
        invoice.company_email = $('.company-email').val();
        invoice.company_address = $('.company-address').val();
      }

      const data = {
        phone: $('.receiver_phone').val(),
        receiver_name: $('.receiver_name').val(),
        discount_code: $('.discount_code').val() === '' ? null : $('.discount_code').val(),
        quantity: order.quantity,
        total: order.total,
        shipping_fee: order.shippingFee,
        address: location.address ? location.address : `${street}, ${location.ward}, ${location.district}, ${location.province}`,
        payment_method: $('input[name="payment"]:checked').val(),
        note: $('.receiver_note').val() === '' ? null : $('.receiver_note').val(),
        invoice: $('input[name="export-invoice"]:checked').val() ? invoice : null,
        vat: order.vat,
        products: order.products
      };

      axios.post('/order', data)
        .then(response => {
          window.location.href = `${window.location.origin}/don-hang/dat-hang-thanh-cong`;
          localStorage.setItem('carts', JSON.stringify([]))
        })
        .catch(error => {
          toastr["error"]('Đã xảy ra lỗi khi gửi yêu cầu, vui lòng thử lại sau.');
          hideLoading();
        });
    });

    $('#exportInvoice').on('shown.bs.collapse', function() {
      const order = getOrder();
      const dataShow = $('.show-company').data('show');
      if (!dataShow) {
        $(this).find('input').prop('required',true);
      }
      console.log(dataShow)
      // invoice.tax_code = null;
      taxVatEle.show();
      $('.order-sub-total').html(formatCurrency(order.totalOrder + order.totalVat) + '₫');
    });

    $('#exportInvoice').on('hidden.bs.collapse', function() {
      $(this).find('input').removeAttr('required');
      taxVatEle.hide();
      const order = getOrder();
      $('.order-sub-total').html(formatCurrency(order.totalOrder) + '₫');
    });

  });
}

function loadProvince() {
  axios.get('/load-province')
    .then(response => {
      let selectProvince = $('#selected-province');
      const provinces = response.data.provinces;
      selectProvince.html(`<option value="">Chọn tỉnh/thành phố</option>`);
      provinces.forEach(item => {
        selectProvince.append(`<option data-name="${item.name_with_type}" value="${item.code}">${item.name_with_type}</option>`);
      });
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function loadProductCartIntoCheckoutPage() {
  const order = getOrder();
  const orderListEle = $('.order-list');
  const carts = JSON.parse(localStorage.getItem('carts'));
  const vat = $('.vat');
  vat.html(formatCurrency(order.totalVat) + '₫')

  if ($('#checkout').data('cart') === false) {
    window.location.href = '/';
  }

  orderListEle.html('');
  carts.forEach(product => {
    const discounted = product.price * ((100 - product.discount) / 100);
    const total = discounted * product.quantity;
    orderListEle.append(`
      <tr>
        <td>
          <img width="80" src="${product.image}" alt="${product.name}">
        </td>
        <td>
          <p class="order-name">${product.name}</p>
          ${product.discount ? `<p class="discounter">Giảm giá: ${product.discount}%</p>` : ''}
          ${product.size ? `<p class="size">Kích cỡ: ${product.size}</p>` : ''}
        </td>
        <td>
          <p class="text-center">${product.quantity}</p>
        </td>
        <td>
          <p class="text-center">${formatCurrency(total + '₫')}</p>
        </td>
      </tr>
    `);
  });
  $('.order-total-quantity').html(order.quantity);
  $('.order-total').html(formatCurrency(order.total) + '₫');
  $('.order-sub-total').html(formatCurrency(order.totalOrder) + '₫');
}

function getOrder() {
  const carts = JSON.parse(localStorage.getItem('carts'));
  let total = 0;
  let quantity = 0;
  let shippingFee = $('.shipping-fee').data("shipping");
  const vat = $('.vat').data('vat');

  carts.forEach(product => {
    const discounted = product.price * ((100 - product.discount) / 100);
    quantity += product.quantity;
    total += product.quantity * discounted;
  });

  let totalVat = total * (vat/100);

  return {
    vat: vat,
    quantity: quantity,
    shippingFee: shippingFee,
    total: total,
    totalOrder: total + shippingFee,
    totalVat: totalVat,
    products: carts
  }
}
